import $ from 'jquery';

$(window).scroll(function () {
    if ($(this).scrollTop() > 40) {
        $('#frameParentInfo').addClass('sticky');
    } else {
        $('#frameParentInfo').removeClass('sticky');
    }
});